// SL HOME — Availability spec island
// -----------------------------------
// Keeps the Availability row in the SL specs table in sync with the selected
// variant. Mirrors the stock product-inventory.js pattern: listen for the
// theme's productSelect event on the closest section, then morph this element's
// children from the freshly rendered <aaa-product-specs> in the response HTML.
// All availability logic lives in blocks/aaa-product-specs.liquid (server-side);
// this only swaps in the re-rendered markup for the new variant.

import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class AaaProductSpecs extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updated = html.querySelector('aaa-product-specs');
        if (!updated) return;

        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[aaa-product-specs] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('aaa-product-specs')) {
  customElements.define('aaa-product-specs', AaaProductSpecs);
}
